import React, { Component } from "react";

class alertMessage extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    message: "",
    alertType: "" //alert-warning, alert-danger, alert-success and available alerts from bootstrap
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
    this.props.onDuration(event.target.value);
  };
  resetErrorMessage = () => {
    if (this.props.onResetErrorMessage) {
      this.props.onResetErrorMessage();
    }
  };

  render() {
    const message = "Warning !";
    const alertType = "alert-warning"; //alert-warning, alert-danger, alert-success and available alerts from bootstrap

    return (
		// mx-4
      <div
        className={`mx-4 alert alert-dismissible fade show ${this.props.alertType}`}
        role="alert"
      >
        {this.props.message ? this.props.message : 'It looks like we ran into an unexpected issue. Please contact Yodlee Customer Care.'}
      </div>
    );
  }
}

export default alertMessage;
